import { QrdaExportRunDto, QrdaReportRunDto } from '@medone/medonehp-api-client';

// Re-export the enums + DTOs the report-bundle feature needs so components stay decoupled
// from the generated package's name.
export { QrdaAggregationScopes, QrdaCohortTypes, QrdaExportRunStatuses, QrdaReportType } from '@medone/medonehp-api-client';

export type { BundleFileDto, CreateQrdaReportRequest, QrdaExportRunDto, QrdaReportRunDto, QrdaReportRunsSearchDto } from '@medone/medonehp-api-client';

export interface ReportBundleState {
    loading: boolean;
    processing: boolean;
    errorMessage: string | null;
    runs: QrdaReportRunDto[];
    runsTotal: number;
    currentRun: QrdaReportRunDto | null;
    // Live progress of the open report's Cat I child run (per-patient generation/validation),
    // fetched from the existing Cat I getRun endpoint while the report is still running.
    catIProgress: QrdaExportRunDto | null;
}

export const initialReportBundleState: ReportBundleState = {
    loading: false,
    processing: false,
    errorMessage: null,
    runs: [],
    runsTotal: 0,
    currentRun: null,
    catIProgress: null,
};

/** Human-readable byte size for the console cards + files table (e.g. "84 KB", "5.4 MB"). */
export const formatBytes = (bytes: number): string => {
    if (!bytes || bytes <= 0) {
        return '0 B';
    }
    const units = ['B', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
    const value = bytes / 1024 ** i;
    return `${i === 0 ? value : value.toFixed(1)} ${units[i]}`;
};
